<!---
    /**
    * File and all contents are proprietary work of Executives On The Web Ltd
    * and must not be copied or redistributed without express permission.
    *
    * Creates a date picker object that can be used within a form
    *
    * @since 20200609
    * @author Matthew Allen <mallen@executivesontheweb.com>
    *
    * @copyright (c) 2020 Executives On The Web Ltd. All right Reserved.
    */
--->
<template>
    <div class="date-range-picker" :id="id">
        <label>From
            <vc-date-picker 
                mode="single"
                v-model="fromDate"
            />
        </label>
        <label>To
            <vc-date-picker 
                mode="single"
                v-model="toDate"
            />
        </label>
    </div>
</template>

<script>
    export default{
        props: {
            id: String,
            value: {
                default: ''
            }
        },
        data() {
            return {
                fromDate: '',
                toDate: ''
            }
        },
        mounted() {
            if (this.value) {
                const values = this.value.split('|');
                if (values.length) {
                    this.fromDate = values[0];
                    this.toDate = values[1];
                }
            }
        },
        watch: {
            fromDate: function() {
                const fromDate = this.fromDate ? this.fromDate.toISOString() : '';
                const toDate = this.toDate ? this.toDate.toISOString() : '';
                this.$emit( 'input', fromDate+'|'+toDate );
            },
            toDate: function() {
                const fromDate = this.fromDate ? this.fromDate.toISOString() : '';
                const toDate = this.toDate ? this.toDate.toISOString() : '';
                this.$emit( 'input', fromDate+'|'+toDate );
            },
        }
    }
</script>